import * as moment from "moment";

import app from "@Stores/app";

const hasValue = value => value !== undefined && value !== null

export default {
  'create-slot': ({ sort }) => `slot was created at ${sort} position.`,
  'add-page': pages => {
    const [[pageId, changes]] = Object.entries(pages)

    let message = `Page ${pageId} was added`

    if (hasValue(changes.weight)) {
      message += ` with weight ${changes.weight}`
    }

    if (message.includes('with weight')) {
      message = message.replace('with weight', 'with weight and')
    }

    if (hasValue(changes.sort)) {
      message += ` with sort ${changes.sort}`
    }

    return message
  },
  'update-slot': ({ sort }) => `slot was updated${hasValue(sort) ? ` to ${sort} position.` : '.'}`,
  'start-experiment': ({ startedDate, winnerMetric, expirationDate }) => `experiment started at ${moment(startedDate).tz(app.timezone).format('MM/DD/YYYY HH:mm')} with ${winnerMetric} as winner metric and will end at ${moment(expirationDate).tz(app.timezone).format('MM/DD/YYYY HH:mm')}`,
  'update-page': pages => {
    const [[pageId, changes]] = Object.entries(pages)

    let message = `Page ${pageId} was updated`

    if (hasValue(changes.weight)) {
      message += ` with weight ${changes.weight}`
    }

    if (message.includes('with weight')) {
      message = message.replace('with weight', 'with weight and')
    }

    if (hasValue(changes.sort)) {
      message += ` with sort ${changes.sort}`
    }

    return message
  },
  'reset-experiment': ({ isManualReset }) => {
    let message = `The experiment was automatically reseted.`

    if (isManualReset) {
      message = `The experiment was manually reseted.`
    }

    return message
  },
  'end-experiment': ({ pageWinnerId }) => pageWinnerId ? `The experiment was ended with page ${pageWinnerId} as winner.` : `The experiment was ended manually disabled.`,
  'remove-page': data => `page ${Object.keys(data)[0]} was removed`,
  'update-experiment': ({ optimize: { winnerMetric, expirationDate } = {} }) => {
    let message = `Experiment was updated`

    if (winnerMetric) {
      message += ` with ${winnerMetric.toUpperCase()} as winner metric`
    }

    if (expirationDate) {
      message += ` and will end at ${moment(expirationDate).tz(app.timezone).format('MM/DD/YYYY HH:mm')}`
    }

    return message
  },
}
